let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iTDMv")).then(() => parcelRequire('1lGKV'));